import { ProgressSpinner } from "primereact/progressspinner";
import { columnSettings } from "./report-template-setting";

const MobileList = ({ listData, loading, groupNames, groupMap }) => {
    const groups = {};
    listData.forEach((row) => {
        const key = row.group_label || row.data_trailer?.nomor || "-";
        if (!groups[key]) groups[key] = [];
        groups[key].push(row);
    });

    const settings = {};
    for (let column of columnSettings) {
        settings[column.field] = column;
    }

    const totalMasalah = groupNames?.reduce(
        (sum, name) => sum + (groupMap[name]?.group_count || 0),
        0
    );

    return (
        <div className="flex flex-col gap-4 p-4">
            {loading && (
                <div className="flex justify-center">
                    <ProgressSpinner />
                </div>
            )}

            {!loading && Object.keys(groups).length === 0 && (
                <p className="text-center text-slate-500">No data available</p>
            )}

            {/* Mobile Summary Card */}
            {!loading && groupNames && groupNames.length > 0 && (
                <div className="bg-zinc-50 rounded-xl shadow-sm border border-zinc-200 overflow-hidden">
                    {/* Header */}
                    <div className="bg-indigo-100 px-4 py-2 font-semibold text-indigo-800 border-b border-zinc-200">
                        SUMMARY LAPORAN
                    </div>

                    {/* Group summary rows */}
                    <div className="px-4 py-2 bg-white flex flex-col gap-2">
                        {groupNames.map((groupName, idx) => {
                            const group = groupMap[groupName];
                            if (!group) return null;
                            const groupData = group.group_data;

                            return (
                                <div
                                    key={`summary-${idx}`}
                                    className="flex justify-between border-b border-zinc-200 pb-1 last:border-b-0"
                                >
                                    <span>{groupData.nomor}</span>
                                    <span>{group.group_count.toLocaleString("id-ID")}</span>
                                </div>
                            );
                        })}
                    </div>

                    {/* Total Masalah footer */}
                    <div className="px-4 py-2 bg-indigo-50 text-indigo-800 font-semibold text-right">
                        TOTAL MASALAH: {totalMasalah.toLocaleString("id-ID")}
                    </div>
                </div>
            )}

            {/* Grouped detail cards */}
            {!loading &&
                Object.keys(groups).map((key) => {
                    const groupRows = groups[key];
                    const groupData = groupRows[0].group_data || groupRows[0].data_trailer;

                    return (
                        <div
                            key={groupData.nomor}
                            className="bg-zinc-50 rounded-xl shadow-sm border border-zinc-200 overflow-hidden"
                        >
                            {/* Group header */}
                            <div className="bg-indigo-100 px-4 py-2 font-semibold text-indigo-800 border-b border-zinc-200">
                                {groupData.nomor}
                            </div>

                            {/* Detail rows */}
                            {groupRows
                                .filter((row) => row.report_type === "detail")
                                .map((row, index) => (
                                    <div
                                        key={row.mykey ?? index}
                                        className="px-4 py-2 border-b border-zinc-200 bg-white"
                                    >
                                        {columnSettings
                                            .filter((col) => col.field !== "no")
                                            .map((col) => {
                                                let value = row[col.field];

                                                if (col.type === "number" && value !== null && value !== undefined) {
                                                    value = value.toLocaleString("id-ID");
                                                } else if (col.type === "date" && value) {
                                                    value = new Date(value).toLocaleDateString("id-ID", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    });
                                                } else if (value === null || value === undefined) {
                                                    value = "-";
                                                } else if (typeof value === "object" && value?.nama) {
                                                    value = value.nama;
                                                }

                                                if (col.field === "keterangan") {
                                                    return (
                                                        <div key={col.field} className="flex flex-col mb-1">
                                                            <span className="text-slate-600 font-bold">{col.name}:</span>
                                                            <span className="text-slate-800">{value}</span>
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <div className="row-between-start mb-1" key={col.field}>
                                                        <span className="text-slate-600 font-bold">{col.name}:</span>
                                                        <span className="text-slate-800">{value}</span>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ))}

                            {/* Group footer */}
                            <div className="px-4 py-2 bg-indigo-50 text-indigo-800 font-semibold text-right">
                                Total Masalah:{" "}
                                {groupRows.filter((row) => row.report_type === "detail").length.toLocaleString(
                                    "id-ID"
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default MobileList;
